import React from 'react';
import { colors, dimensions, typography } from '../../theme';
import type { SoundTab } from '../hooks/use-sound-panel-state';

type SoundTabsNavProps = {
  activeTab: SoundTab;
  onChange: (tab: SoundTab) => void;
};

const TABS: { id: SoundTab; label: string }[] = [
  { id: 'voiceover', label: 'Locución' },
  { id: 'music', label: 'Música' }
];

/** Barra de tabs Locución / Música del SoundPanel. Componente controlado. */
export const SoundTabsNav: React.FC<SoundTabsNavProps> = ({ activeTab, onChange }) => (
  <div style={{ display: 'flex', borderBottom: `1px solid ${colors.border}` }}>
    {TABS.map(tab => {
      const active = activeTab === tab.id;
      return (
        <button
          key={tab.id}
          onClick={() => onChange(tab.id)}
          style={{
            flex: 1,
            padding: `${dimensions.spacing.xl}px ${dimensions.spacing.xl}px`,
            background: 'transparent',
            border: 'none',
            borderBottom: `2px solid ${active ? colors.accent : 'transparent'}`,
            color: active ? colors.accent : colors.textSecondary,
            fontSize: typography.fontSize.md,
            fontWeight: active ? typography.fontWeight.semibold : typography.fontWeight.medium,
            fontFamily: typography.fontFamily.ui,
            cursor: 'pointer',
            transition: 'color 0.15s, border-color 0.15s'
          }}
        >
          {tab.label}
        </button>
      );
    })}
  </div>
);
